export const serviceSectors = [
  {
    slug: "oil-gas",
    title: "Oil & Gas Staffing",
    shortTitle: "Oil & Gas",
    shortDesc: "We provide specialized professionals for the oil and gas industry, from drilling operations to refinery management and environmental compliance.",
    image: "/img_to_use/oil and gas.jpg",
    bullets: [
      "Drilling Engineers",
      "Production Operators",
      "Safety Officers",
      "Geologists",
      "Process Engineers",
      "Maintenance Technicians"
    ],
    fullDesc: `
      <p>We provide specialized professionals for the oil and gas industry, from drilling operations to refinery management and environmental compliance. Our candidates have extensive experience in upstream, midstream, and downstream operations.</p>
      <strong>Key roles we fill:</strong>
      <ul>
        <li>Drilling Engineers & Technicians</li>
        <li>Production & Operations Staff</li>
        <li>Health, Safety & Environment Officers</li>
        <li>Geologists & Geophysicists</li>
        <li>Process & Chemical Engineers</li>
        <li>Maintenance & Inspection Technicians</li>
        <li>Project Managers</li>
        <li>Quality Control Specialists</li>
      </ul>
    `
  },
  {
    slug: "infrastructure",
    title: "Infrastructure Staffing",
    shortTitle: "Infrastructure",
    shortDesc: "We deliver infrastructure professionals for large-scale construction, transportation, and utilities projects that build the foundation of modern society.",
    image: "/img_to_use/Infrastructure.jpg",
    bullets: [
      "Civil Engineers",
      "Project Managers",
      "Construction Supervisors",
      "Urban Planners",
      "Structural Engineers",
      "Environmental Consultants"
    ],
    fullDesc: `
      <p>We deliver infrastructure professionals for large-scale construction, transportation, and utilities projects that build the foundation of modern society. Our network includes experts in roads, bridges, water systems, and smart city development.</p>
      <strong>Key roles we fill:</strong>
      <ul>
        <li>Civil & Structural Engineers</li>
        <li>Project & Construction Managers</li>
        <li>Construction Supervisors & Foremen</li>
        <li>Urban & Transportation Planners</li>
        <li>Environmental & Sustainability Consultants</li>
        <li>Utilities & Power System Engineers</li>
        <li>Surveying & GIS Specialists</li>
        <li>Infrastructure Asset Managers</li>
      </ul>
    `
  },
  {
    slug: "it-staffing",
    title: "IT Staffing",
    shortTitle: "IT Staffing",
    shortDesc: "We deliver skilled IT professionals to support your digital transformation, software development, infrastructure management, and cybersecurity needs.",
    image: "/img_to_use/campaign-creators-8F4EX4Nw1yY-unsplash.jpg",
    bullets: [
      "Software Developers",
      "Data Scientists & Analysts",
      "Cloud Engineers",
      "DevOps & SREs",
      "Cybersecurity Specialists",
      "Business Analysts"
    ],
    fullDesc: `
      <p>We deliver skilled IT professionals to support your digital transformation, software development, infrastructure management, and cybersecurity needs. From short-term projects to long-term engagements, we provide flexible staffing solutions tailored to your technology goals.</p>
      <strong>Key roles we fill:</strong>
      <ul>
        <li>Software Developers (Frontend, Backend, Full Stack)</li>
        <li>Data Scientists & Analysts</li>
        <li>Cloud Engineers (AWS, Azure, GCP)</li>
        <li>DevOps & Site Reliability Engineers</li>
        <li>Cybersecurity Specialists</li>
        <li>Business Analysts & Product Managers</li>
        <li>QA/Test Automation Engineers</li>
        <li>IT Project Managers</li>
        <li>Network & System Administrators</li>
      </ul>
    `
  },
  {
    slug: "healthcare-staffing",
    title: "Healthcare Staffing",
    shortTitle: "Healthcare",
    shortDesc: "We connect healthcare organizations with compassionate, credentialed professionals who deliver top-tier patient care and operational excellence.",
    image: "/img_to_use/helthcare.jpg",
    bullets: [
      "Registered Nurses",
      "Nurse Practitioners",
      "Medical Assistants",
      "Physicians",
      "Lab Technicians",
      "Healthcare Admins"
    ],
    fullDesc: `
      <p>We connect healthcare organizations with compassionate, credentialed professionals who deliver top-tier patient care and operational excellence. Whether you need support in clinical care, medical administration, or allied health, we ensure talent that fits your needs.</p>
      <strong>Key roles we fill:</strong>
      <ul>
        <li>Registered Nurses (RN, BSN)</li>
        <li>Nurse Practitioners</li>
        <li>Medical Assistants & CNAs</li>
        <li>Physicians & Surgeons</li>
        <li>Laboratory Technicians</li>
        <li>Radiologic & Imaging Technologists</li>
        <li>Medical Billing & Coding Specialists</li>
        <li>Healthcare Administrators</li>
        <li>Pharmacy Technicians</li>
      </ul>
    `
  },
  {
    slug: "logistics-supply-chain",
    title: "Logistics & Supply Chain Staffing",
    shortTitle: "Logistics",
    shortDesc: "We provide logistics and supply chain professionals who optimize operations, ensure timely delivery, and support scalable growth.",
    image: "/img_to_use/logistics.jpg",
    bullets: [
      "Logistics Coordinators",
      "Supply Chain Analysts",
      "Warehouse Supervisors",
      "Fleet Managers",
      "Inventory Specialists",
      "Procurement Officers"
    ],
    fullDesc: `
      <p>We provide logistics and supply chain professionals who optimize operations, ensure timely delivery, and support scalable growth. Our candidates are vetted for their experience in fast-paced, deadline-driven environments.</p>
      <strong>Key roles we fill:</strong>
      <ul>
        <li>Logistics Coordinators</li>
        <li>Supply Chain Analysts</li>
        <li>Warehouse Supervisors & Associates</li>
        <li>Transportation & Fleet Managers</li>
        <li>Inventory Control Specialists</li>
        <li>Procurement Officers</li>
        <li>Import/Export Compliance Analysts</li>
        <li>Freight Brokers & Dispatchers</li>
      </ul>
    `
  },
  {
    slug: "engineering-epc",
    title: "Engineering & EPC Staffing",
    shortTitle: "Engineering & EPC",
    shortDesc: "We provide talent for every phase of EPC projects, from initial design and procurement to construction and commissioning.",
    image: "/img_to_use/home page enginner 1.jpg",
    bullets: [
      "Design Engineers",
      "Procurement Managers",
      "Project Controllers",
      "Construction Managers",
      "Commissioning Engineers",
      "QA Specialists"
    ],
    fullDesc: `
      <p>We provide talent for every phase of EPC projects, from initial design and procurement to construction and commissioning. Our network includes engineers, procurement specialists, project controllers, and site managers with experience in complex, multidisciplinary projects.</p>
      <p>We help you assemble teams that deliver quality, safety, and efficiency at every stage.</p>
      <strong>Key roles we fill:</strong>
      <ul>
        <li>Design Engineers</li>
        <li>Procurement Managers</li>
        <li>Project Controllers</li>
        <li>Construction Managers</li>
        <li>Commissioning Engineers</li>
        <li>Quality Assurance Specialists</li>
        <li>Site Engineers</li>
        <li>HSE (Health, Safety, Environment) Officers</li>
        <li>Structural & Civil Engineers</li>
      </ul>
    `
  },
  {
    slug: "fmcg-retail",
    title: "FMCG & Retail Staffing",
    shortTitle: "FMCG & Retail",
    shortDesc: "We provide retail and FMCG professionals who drive sales, manage operations, and deliver exceptional customer experiences.",
    image: "/img_to_use/FMCG.jpg",
    bullets: [
      "Store Managers",
      "Sales Associates",
      "Brand Managers",
      "Merchandisers",
      "Inventory Coordinators",
      "Customer Service Reps"
    ],
    fullDesc: `
      <p>We provide retail and FMCG professionals who drive sales, manage operations, and deliver exceptional customer experiences. Our candidates understand the fast-paced retail environment and consumer behavior.</p>
      <strong>Key roles we fill:</strong>
      <ul>
        <li>Store Managers & Assistant Managers</li>
        <li>Sales Associates & Representatives</li>
        <li>Brand Managers & Marketing Specialists</li>
        <li>Visual Merchandisers</li>
        <li>Inventory Coordinators</li>
        <li>Customer Service Representatives</li>
        <li>Category Managers</li>
        <li>Regional Sales Managers</li>
        <li>Loss Prevention Officers</li>
      </ul>
    `
  },
  {
    slug: "engineering-procurement-construction",
    title: "Engineering Procurement & Construction",
    shortTitle: "Engineering Procurement & Construction",
    shortDesc: "We provide comprehensive staffing solutions for EPC projects, covering design, procurement, construction, and commissioning phases with experienced professionals.",
    image: "/img_to_use/Engineering Procurement & Construction.jpg",
    bullets: [
      "Project Engineers",
      "Procurement Specialists",
      "Construction Managers",
      "Design Engineers",
      "Commissioning Engineers",
      "Site Supervisors"
    ],
    fullDesc: `
      <p>We provide comprehensive staffing solutions for EPC (Engineering, Procurement & Construction) projects, covering all phases from conceptual design to final commissioning. Our network includes experienced professionals who understand the complexities of large-scale industrial projects.</p>
      <p>Whether you're building power plants, petrochemical facilities, or industrial infrastructure, we deliver the right talent to ensure project success.</p>
      <strong>Key roles we fill:</strong>
      <ul>
        <li>Project Engineers & Coordinators</li>
        <li>Procurement Specialists & Managers</li>
        <li>Construction Managers & Supervisors</li>
        <li>Design Engineers (Mechanical, Electrical, Civil)</li>
        <li>Commissioning & Startup Engineers</li>
        <li>Site Supervisors & Foremen</li>
        <li>Quality Control Inspectors</li>
        <li>Safety & HSE Officers</li>
        <li>Planning & Scheduling Specialists</li>
      </ul>
    `
  }
]; 